<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 4" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="306px" height="200px" animated />
      <shSkeleton bg="#e4e4e4" width="260px" height="35px" animated />
      <shSkeleton bg="#e4e4e4" width="120px" height="24px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 1240px;
  height: 300px;
  display: flex;

  justify-content: space-between;
  .item {
    width: 306px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 10px auto 0;
    }
  }
}
</style>
